import { EmployeeService } from "../services/employee/employee.service";
import { store } from "../store/store";

export const SET_EMPLOYEES = 'SET_EMPLOYEES';

export const fetchEmployees = async () => {
    const res = await EmployeeService.getEmployees();
    store.dispatch(setEmployees(res));
}

export const setEmployees = (data: any) => {
    return {
        type: SET_EMPLOYEES,
        data
    }
}
